<template>
  <div class="mb-sm-4 mx-3 my-4 row">
    <div class="row-equal-height">
      <div class="col-lg-7 mb-3">
        <div class="border">
          <div class="row p-4">
            <div ref="mask" class="col">
              <h5 class="h5 text-muted font-weight-bold">{{ title }}</h5>
              <p>{{ prompt }}</p>
              <div class="form-group pt-2">
                <label class="h6 font-weight-bold d-block">Select File Type</label>
                <b-form-select
                  v-model="selectedFileType"
                  class="form-control"
                  :options="options"
                ></b-form-select>
              </div>
              <div v-if="selectedFileType === 'Data'" class="form-group pt-2">
                <label class="h6 font-weight-bold d-block">Frequency</label>
                <b-form-select
                  v-model="frequency"
                  class="form-control"
                  :options="frequencyOptions"
                ></b-form-select>
              </div>

              <el-upload
                ref="drag"
                drag
                :on-error="_handleError"
                :before-upload="_handleBeforeUpload"
                action="#"
                :accept="accept"
                :http-request="_handleFileSelected"
                :on-success="_handleSuccess"
                :file-list="form.dragList"
                :on-change="onFileChange"
              >
                <div class="el-upload__text">
                  <div>
                    <i class="el-icon-upload"></i>
                  </div>
                  <em
                    style="font-size: 21px; text-decoration: underline"
                    class="text-primary font-weight-bold"
                    >Upload {{ accept }} file</em
                  >
                </div>
              </el-upload>
            </div>
          </div>
          <div class="row pt-2 px-4 py-4">
            <div class="col">
              <button
                :disabled="disable || loading || isProcessing"
                class="btn float-left btn-primary btn-action shadow px-5 py-3"
                @click="proceed"
              >
                <i v-if="loading || isProcessing" class="el-icon-loading mr-2"></i>
                {{ actionText }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 border bg-gray mb-3">
        <div class="row p-4">
          <div class="col">
            <h5 class="h5 font-weight-bold">Download Import File Template</h5>
            <p>
              Use this template to structure and arrange the data before uploading it back here.
            </p>

            <p class="text-danger font-weight-bold">
              Please note that the DMI might not be able to process data arranged in any other way
              besides that specified in this template.
            </p>

            <div v-if="max" class="d-flex align-items-center">
              <span>
                Maximum file size: <b>{{ max }}KB</b>
              </span>
              <!-- <a style="text-decoration: underline" class="btn btn-link text-muted pl-5"
                >Read help documentation</a
              > -->
            </div>
          </div>
        </div>
        <div class="row px-4">
          <a
            :href="require(`@/assets/data/${selectedFileType}.xlsx`)"
            target="_blank"
            class="btn btn-link"
            :download="`${selectedFileType}-template.xlsx`"
            style="text-decoration: underline"
          >
            Download Template (
            {{ selectedFileType ? `Selected file type: ${selectedFileType}` : "Select file type!" }}
            )
          </a>
        </div>
      </div>
    </div>

    <!-- shows a prompt , properties are defined in Mixin Object -->
    <ProgressPrompt
      :width="promptWidth"
      :visible="isProgresPromptVisible"
      :cancel="promptCancel"
      :confirm="promptConfirm"
      :message="promptMessage"
      :title="promptTitle"
      :cancel-text="promptCancelText"
      :cancel-type="promptCancelClass"
      :confirm-text="promptConfirmText"
      :confirm-type="promptConfirmClass"
      @close="onPromptClose"
    />
  </div>
</template>

<script>
import DataMixin from "../views/data/mixin";
import UploadResource from "../api/fileResource";
import { META_DATA_CHECK_STAGE } from "../store/stages";
// import XLSX from "xlsx";
import { mapGetters } from "vuex";
import { random } from "../utils";
import readXlsxFile from "read-excel-file";
import { logDataAction } from "../utils/activityLogger";

const uploadResource = new UploadResource();
var xlsxData;

export default {
  name: "UploadComponent",
  mixins: [DataMixin],
  props: {
    actionText: {
      type: String,
      default: "Proceed",
    },

    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     *
     */
    title: {
      type: String,
      default: "Update Data from file or link",
    },
    /**
     *
     */
    prompt: {
      type: String,
      default:
        "Done structuring the data? You can import it to the DMI by uploading the edited .xsl file or by pasting a link to it here.",
    },
    /**
     *
     */
    max: {
      type: Number,
      default: 0,
    },
    /**
     *
     */
    accept: {
      type: String,
      default: ".xlsx",
    },
    // eslint-disable-next-line vue/require-default-prop
    handleBeforeUpload: {
      type: Function,
    },
    // eslint-disable-next-line vue/require-default-prop
    handleError: {
      type: Function,
    },
    // eslint-disable-next-line vue/require-default-prop
    handleSuccess: {
      type: Function,
    },
  },
  data() {
    return {
      form: {
        url: null,
        dragList: [],
      },
      selectedFile: undefined,
      selectedFileType: "Data",
      isProcessing: false,
      frequency: "annual",
      frequencyOptions: [
        { value: "annual", text: "Annual" },
        { value: "quarterly", text: "Quarterly" },
        { value: "monthly", text: "Monthly" },
        { value: "weekly", text: "Weekly" },
      ],
      options: [
        { value: null, text: "Please select an option" },
        { value: "Data", text: "Data" },
        { value: "Indicator", text: "Indicator" },
        { value: "Datasource", text: "Datasource" },
        { value: "Location", text: "Location" },
        { value: "ValueType", text: "ValueType" },
        { value: "Factor", text: "Factor" },
        { value: "Demographic", text: "Demographic" },
        { value: "DataSourceSpecificIndicator", text: "DataSourceSpecificIndicator" },
      ],
    };
  },
  computed: {
    /**
     * Get data state from store
     */
    ...mapGetters({
      originalFile: "data/file",
    }),
  },

  watch: {
    selectedFileType(newFile) {
      console.log(newFile);

      if (newFile) {
        this.$store.commit("data/setDataType", this.selectedFileType);
      }
    },
  },

  methods: {
    /**
     * confirm proceed
     */
    beforeProceed() {
      this.showProgressPrompt("Save File", "Are you done editting?", {
        cancel: "No",
        confirm: "Yes",
        confirmClass: "success",
        async confirmCallback() {
          this.proceed();
        },
      });
    },
    /**
     *Navigates to  next index on the  Next index Navigation Bar
     @see {NavigationSubNav}
     */
    async proceed() {
      if (!this.form.url && !this.selectedFile && !this.selectedFileType) {
        return this.$message({
          message: "No File/Url provided",
          type: "error",
          duration: 5 * 1000,
        });
      }
      const formData = new FormData();
      formData.append("name", this.selectedFile.name);
      localStorage.setItem("name", this.selectedFile.name);
      formData.append("application", "DMI");
      formData.append("type", "unnormalized");
      formData.append("file_type", this.selectedFileType);
      localStorage.setItem("file_type", this.selectedFileType);
      formData.append("ordinary_data", this.selectedFile);
      localStorage.setItem("ordinary_data", JSON.stringify(this.selectedFile));
      formData.append("frequency", this.frequency);
      localStorage.setItem("frequency", this.frequency);
      formData.append("approved", false);
      await this.setRequestProgress(random(35, 55));
      this.$progress.start();
      this.isProcessing = true;

      uploadResource
        .create(formData)
        .then(async (response) => {
          console.log("upload resouce create res", response);
          localStorage.setItem("currentRecordId", response.data.id);
          let responseData = [],
            responseDataObj = {};
          responseData.push(response);
          // eslint-disable-next-line no-unused-vars
          responseDataObj = {
            data: responseData,
          };
          localStorage.setItem("getCurrentFileData", JSON.stringify(response));

          // Log file upload activity
          logDataAction("fileUpload", {
            id: response.data.id,
            filename: this.selectedFile.name,
            name: this.selectedFile.name,
            fileType: this.selectedFileType,
          });

          // await uploadResource
          //   .getData()
          //   .then((data) => {
          //     console.log("data", data);
          //     responseData = data;
          //   })
          //   .catch((e) => console.log(e));
          await this.$store.dispatch("data/setData", xlsxData);
          this.$store.commit("data/SET_STAGE", META_DATA_CHECK_STAGE);
          await this.setRequestProgress(100);

          this.$router
            .push("/data/preview")
            .then(() => {})
            .catch((e) => console.error(e));
        })
        .catch(async (error) => {
          console.error(error);
          this.$notify.error({
            title: "Error Uploading file",
            message: "An error occurred!",
          });
          await this.setRequestProgress(random(70, 90));
        })
        .finally(() => {
          this.$progress.done();
          this.isProcessing = false;
        });
    },
    /**
     *
     */
    // eslint-disable-next-line no-unused-vars
    _handleError(error, file, fileList) {
      if (this.handleError) return this.handleError(error, file, fileList);
      if (error.response?.status) return; // request errors are handled automatically
      return this.$notify.error({
        title: "Error Uploading file",
        message: error,
        duration: 0,
      });
    },
    /**
     *
     */
    // eslint-disable-next-line no-unused-vars
    _handleSuccess(response, file, fileList) {
      if (this.handleSuccess) return this.handleSuccess(response, file, fileList);
    },
    /**
     *
     */
    _handleBeforeUpload(file) {
      if (this.max > 0) {
        let max_size = this.max * 1024;
        if (file.size > max_size) {
          this.$notify.closeAll();
          this.$notify.error({
            title: "Upload error",
            message: `Maximum file size ${this.max}KB exceeded`,
            duration: 0,
          });
          return false;
        }
      }
      if (this.handleBeforeUpload) return this.handleBeforeUpload(file);
    },
    /**
     *
     */
    clearFiles() {
      this.$refs["drag"].clearFiles();
    },
    // eslint-disable-next-line no-unused-vars
    async _handleFileSelected({ file }) {
      this.selectedFile = file;
    },
    onFileChange(event) {
      // let xlsxfile = event.target.files ? event.target.files[0] : null;
      let xlsxfile = event.raw;
      console.log("selected file type is:", this.selectedFileType);
      readXlsxFile(xlsxfile).then((rows) => {
        // xlsxData = rows;
        if (this.selectedFileType === "Indicator") {
          xlsxData = rows
            .map((item) => {
              return {
                full_name: item[0],
                short_name: item[1],
                factor: item[2],
                desirable_slope: item[3],
                indicator_type: item[4],
                program_area: item[5],
                national_target: item[6],
                national_source: item[7],
                national_information: item[8],
                sdg_target: item[9],
                sdg_information: item[10],
                first_related: item[11],
                second_related: item[12],
                third_related: item[13],
                fourth_related: item[14],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "Data") {
          xlsxData = rows
            .map((item) => {
              return {
                indicator: item[0],
                period: item[1],
                location: item[3],
                datasource: item[2],
                value: item[4],
                value_type: item[5],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "Datasource") {
          xlsxData = rows
            .map((item) => {
              return {
                datasource: item[0],
                full_name: item[1],
                description: item[2],
                year_available: item[3],
                period_available: item[4],
                methodology: item[5],
                subnational_data: item[6],
                classification: item[7],
                link: item[8],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "Location") {
          xlsxData = rows
            .map((item) => {
              return {
                name: item[0],
                parent: item[1],
                level: item[2],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "ValueType") {
          xlsxData = rows
            .map((item) => {
              return {
                value_type: item[0],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "Factor") {
          xlsxData = rows
            .map((item) => {
              return {
                multiplier_factor: item[0],
                display_factor: item[1],
              };
            })
            .slice(1);
        }
        if (this.selectedFileType === "DataSourceSpecificIndicator") {
          xlsxData = rows
            .map((item) => {
              return {
                indicator: item[0],
                datasource: item[1],
                datasource_indicator: item[2],
                measurement_numerator: item[3],
                measurement_denominator: item[4],
                frequency: item[5],
                methodology_estimation: item[6],
                indicator_definition: item[7],
                data_level: item[8],
                national: item[9],
                zonal: item[10],
                state: item[11],
                senatorial: item[12],
                lga: item[13],
              };
            })
            .slice(1);
        }
        console.log("rows:", xlsxData);
      });
    },
  },

  mounted() {
    this.$store.commit("data/setDataType", "Data");
  },
};
</script>

<style>
.row-equal-height {
  display: flex;
  flex-wrap: wrap;
}

/* Add a class to specify equal height for immediate children */
.row-equal-height > div {
  flex: 1;
}
</style>
